import * as React from 'react';
import { observer } from 'mobx-react';
import Link from '@src/components/link';
import cx from 'classnames';

const styles = require('./index.less');

const ArticleBtn = ({ store }) => {
  store.use();
  return (
    <React.Fragment>
      <Link
        onClick={() => {
          store.gotoDetail(store.prevData);
        }}
        className={cx('news-detail-group-8-n', store.prevData?.title && 'news-detail-group-8')}
        data-name="上一篇"
      >
        <div className="news-detail-layer-14-prev" />
        <div className="news-detail-layer-15" data-name="迎国庆 轻松卡携集卡活动上线">
          {store.prevData?.title || '没有了'}
        </div>
      </Link>
      <Link
        onClick={() => {
          store.gotoDetail(store.nextData);
        }}
        className={cx('news-detail-group-8-n', store.nextData?.title && 'news-detail-group-8')}
        data-name="下一篇"
      >
        <div className="news-detail-layer-14" />
        <div className="news-detail-layer-15" data-name="《剑侠世界3》8月6日更新预告">
          {store.nextData?.title || '没有了'}
        </div>
      </Link>
    </React.Fragment>
  );
};

export default observer(ArticleBtn);
